export enum ReadingContentTypeEnum {
    TEXT = 'TEXT',
    COMMAND = 'COMMAND'
}
